import { Box, constants, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';

import { LocalisableLink } from '../LocalisableLink';
import styles from './UserAgreement.module.scss';

export const messages = defineMessages({
  ariaLabel: {
    defaultMessage: 'User Agreement',
  },
  prompt: {
    defaultMessage:
      'By proceeding to checkout, I agree to Redbubble’s <link>User Agreement</link>',
  },
});

const agreementUrl = '/agreement';

type Variant = 'default' | 'subtle';

interface UserAgreementProps {
  variant?: Variant;
}

export const UserAgreement: React.FC<UserAgreementProps> = ({
  variant = 'default',
}) => {
  const intl = useIntl();
  const agreementCopy = intl.formatMessage(messages.prompt, {
    link: LocalisableLink(agreementUrl, () => {}),
  });

  return (
    <Box
      className={styles.wrapper}
      textAlign={variant === 'subtle' ? constants.LEFT : constants.CENTER}
      aria-label={intl.formatMessage(messages.ariaLabel)}
    >
      {variant === 'subtle' ? (
        <Text type="body2">{agreementCopy}</Text>
      ) : (
        agreementCopy
      )}
    </Box>
  );
};
